import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterPagoPremioView.
 * @extends JetView
 */
export default class FilterPagoPremioView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Get screen size configuration
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for ticket number
                            name: 'NoTicket',
                            id: 'NoTicket',
                            type: 'number',
                            label: "<span class='icon-ticket'></span>" + _('No. Ticket'),
                            labelPosition: 'top',
                            placeholder: _('No. Ticket'),
                            required: true, // Field is required
                            invalidMessage: _('Campo Requerido'), // Error message for invalid input
                        },
                        {
                            view: 'text', // Password input for ticket key
                            name: 'ClaveTicket',
                            id: 'ClaveTicket',
                            type: 'password',
                            label: "<span class='icon-ticket1'></span>" + _('Clave Ticket'),
                            labelPosition: 'top',
                            placeholder: _('Clave Ticket'),
                            required: true, // Field is required
                            invalidMessage: _('Campo Requerido'), // Error message for invalid input
                            attributes: {
                                autocomplete: 'new-password', // Prevents browser from auto-filling
                            },
                        },
                        { id: 'grav5', gravity: 1 }, // Placeholder for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            height: screen == 'small' ? 130 : 0, // Adjust height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };
        const datos = {
            // Sample data for payment information
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav4', gravity: 4 }, // Placeholder for layout
                        {
                            view: 'button', // Button to clear the form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                                $$('formPagoPremio').hide(); // Hide payment form
                                $$('toolbar').hide(); // Hide toolbar
                                $$('tablePagoPremio').hide(); // Hide payment table
                            },
                        },
                        {
                            view: 'button', // Button to consult payment
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            hotkey: 'enter', // Enter key to trigger button
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                const regex = /^\d+$/; // Regex to validate ticket number
                                if (!regex.test(filterdata.NoTicket)) {
                                    webix.message({
                                        type: 'error',
                                        text: _(
                                            'No. Ticket debe contener solo números.', // Error message for invalid ticket number
                                        ),
                                    });
                                } else if (this.getRoot().validate()) {
                                    // Validate form
                                    this.app.callEvent('pagoPremio2:filter', [
                                        filterdata, // Trigger event with filter data
                                    ]);
                                    const vthis = this; // Preserve context
                                    webix
                                        .ajax() // AJAX request to fetch payment data
                                        .get(
                                            devConfig.geturlApi() + '/UserManagement/GetPagoPremioVirtuales',
                                            'NoTicket=' +
                                                filterdata.NoTicket +
                                                '&ClaveTicket=' +
                                                filterdata.ClaveTicket,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message for AJAX failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    text = JSON.parse(text); // Parse response text
                                                    if (text.HasError) {
                                                        webix.message({
                                                            title: '¡Error!',
                                                            type: 'alert-error',
                                                            text: _(
                                                                'Ticket no encontrado', // Error message for ticket not found
                                                            ),
                                                        });
                                                    } else {
                                                        vthis.app.callEvent(
                                                            'pagoPremio:data',
                                                            [text.data], // Trigger event with fetched data
                                                        );
                                                        $$('FilterPagoPremio').hide(); // Hide filter view
                                                        $$('formPagoPremio').show(); // Show payment form
                                                        $$('tablePagoPremio').show(); // Show payment table
                                                        $$('toolbar').show(); // Show toolbar
                                                        $$('pagerA').show(); // Show pager
                                                        $$('back-button').show(); // Show back button
                                                        if (text.data.Ganador == 'SI') {
                                                            $$('templatemMessage').setHTML(
                                                                '<div class="tck-ganador" style="text-align: center;">' +
                                                                    _(
                                                                        'Ticket Ganador', // Display winner message
                                                                    ) +
                                                                    '</div>',
                                                            );
                                                        } else {
                                                            $$('templatemMessage').setHTML(
                                                                '<div class="tck-perdedor" style="text-align: center;">' +
                                                                    _(
                                                                        'Ticket Perdedor', // Display loser message
                                                                    ) +
                                                                    '</div>',
                                                            );
                                                        }
                                                        if (text.data.Estado == 'A') {
                                                            $$('templatemMessage').setHTML(
                                                                '<div class="tck-default" style="text-align: center;">' +
                                                                    _(
                                                                        'Ticket Pendiente', // Display pending ticket message
                                                                    ) +
                                                                    '</div>',
                                                            );
                                                        }
                                                        if (text.data.Estado == 'A') {
                                                            $$('EstadoT').setValue(
                                                                'Pendiente', // Set state to Pending
                                                            );
                                                        } else if (text.data.Estado == 'I') {
                                                            $$('EstadoT').setValue(
                                                                'Cerrado', // Set state to Closed
                                                            );
                                                        }
                                                        $$('ButtonPagarPremio').hide(); // Hide payment button
                                                        if (text.data.PremioPagado == 'S') {
                                                            $$('templatemMessage').setHTML(
                                                                '<div class="tck-default" style="text-align: center;">' +
                                                                    _(
                                                                        'Premio Pagado', // Display prize paid message
                                                                    ) +
                                                                    '</div>',
                                                            );
                                                        } else {
                                                            if (text.data.Ganador == 'SI') {
                                                                $$('ButtonPagarPremio').show(); // Show payment button if winner
                                                            }
                                                        }
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            id: 'FilterPagoPremio',
            rows: [upper_section, buttons], // Combine upper section and buttons
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        this.validate(); // Validate on change
                        $$('NoTicket').define('inputHeight', 38); // Set input height
                        $$('NoTicket').refresh(); // Refresh input
                        $$('ClaveTicket').define('inputHeight', 38); // Set input height
                        $$('ClaveTicket').refresh(); // Refresh input
                    },
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav4').hide(); // Hide layout element for small screens
                $$('grav5').hide(); // Hide layout element for small screens
            }
        });
    }
}

// FILE DOCUMENTED
